<template>
  <div
    :style="{
      height: `${blockHeight ? `${blockHeight}px` : 'auto'}`,
      'overflow-y': 'auto',
      width: width ? width : 'auto'
    }"
    class="text-xs-center"
  >
    <v-layout column>
      <v-toolbar
        color="white"
        flat
        height="40"
        class="mt-1"
      >
        <v-layout
          v-if="title"
          column
        >
          <v-layout align-center>
            <span class="subheading font-weight-bold">{{ title }}</span>
            <v-spacer v-if="images.length > 0" />
            <ImageUploader
              :id="id"
              :resource="resource"
              :disabled="disabled || loading"
              width="25px"
              @upload="getImages"
            />
          </v-layout>
          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            height="3"
            class="my-1"
          />
        </v-layout>
        <v-layout
          v-else
          column
        >
          <v-layout>
            <v-spacer />
            <v-tooltip left>
              <template slot="activator">
                <span>
                  <ImageUploader
                    :id="id"
                    :resource="resource"
                    :disabled="disabled || loading"
                    @upload="getImages"
                  />
                </span>
              </template>
              <span>Добавить фото</span>
            </v-tooltip>
          </v-layout>
          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            height="3"
            class="my-1"
          />
        </v-layout>
      </v-toolbar>
      <v-list v-if="images.length > 0">
        <v-list-tile
          v-for="item in images"
          :key="item.id"
          class="clickable-row"
        >
          <v-menu
            open-on-hover
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-list-tile-content v-on="on">
                <v-list-tile-title v-text="item.originName" />
              </v-list-tile-content>
            </template>
            <div class="d-flex transition-easy-in-easy-out">
              <v-img :src="item && item.path ? `http://${item.path}` : ''" />
            </div>
          </v-menu>
          <v-list-tile-action>
            <v-layout>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-0"
                    small
                    icon
                    :disable="disabled || loading"
                    v-on="on"
                    @click="download(item.id)"
                  >
                    <v-icon color="grey darken-1">
                      get_app
                    </v-icon>
                  </v-btn>
                </template>
                <span>Скачать фото</span>
              </v-tooltip>
              <v-btn
                class="ma-0"
                small
                icon
                :disable="disabled || loading"
                @click="remove(item.id)"
              >
                <v-icon color="grey darken-1">
                  delete
                </v-icon>
              </v-btn>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-layout>
  </div>
</template>

<script>
import ImageUploader from "./ImageUploader.vue";
import * as imagesApi from "../../backend/imagesApi.js";

export default {
  components: {
    ImageUploader,
  },
  props: [
    "resource",
    "id",
    "blockHeight",
    "isLeft",
    "isTop",
    "width",
    "disabled",
    "title",
  ],
  data() {
    return {
      images: [],
      loading: false,
    };
  },
  created() {
    this.getImages();
  },
  methods: {
    async getImages() {
      this.loading = true;
      this.images = await imagesApi.getImages(this.resource, this.id);
      this.$emit("change", this.images);
      this.loading = false;
    },
    async download(imageId) {
      const res = await imagesApi.downloadImage(this.resource, imageId);
      const sliceSize = 1024;
      const byteCharacters = atob(res.data.ImageData);
      const bytesLength = byteCharacters.length;
      const slicesCount = Math.ceil(bytesLength / sliceSize);
      const byteArrays = new Array(slicesCount);

      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }

      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";

      const blob = new Blob(byteArrays, { type: "octet/stream" });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      const index = this.images.map(item => item.id).indexOf(imageId);
      a.download = this.images[index].originName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    async remove(imageId) {
      this.loading = true;
      await imagesApi.deleteImage(this.resource, this.id, imageId);
      const index = this.images.map(item => item.id).indexOf(imageId);
      this.images.splice(index, 1);
      this.$emit("change", this.images);
      this.loading = false;
      this.showInfo("Фото удалено");
    },
  },
};
</script>
